import { useQuery } from "@tanstack/react-query";
import api from "@/lib/axios-interceptor";

export default function useWindQuery(
  wind: number[] = [10, 20],
  location: "all" | "western" | "eastern" | "central" | "gobi" = "all"
) {
  const isEnabled = wind.length === 2;

  const { data, isLoading, isError } = useQuery<types.Wind[]>({
    queryKey: ["wind", wind, location],
    queryFn: async () => {
      const res = await api.get<types.Wind[]>(
        `/v1/wind/${location}?speed_min=${wind[0]}&speed_max=${wind[1]}`
      );

      return res.data;
    },
    enabled: isEnabled,
    // staleTime: 60 * 60 * 1000, // 1 цагийн cache (хүсвэл)
  });

  return {
    data,
    isLoading,
    isError,
  };
}
